module.exports = __webpack_public_path__ + "img/front-dark.62e111a7.png";